import { observable, makeObservable } from 'mobx'
import { DocumentTypeDTO, UploaderUserType } from './dtos/document-type'
import { Model } from 'infra/model'
import { Id } from 'types/definitions'
import { once } from 'lodash'

export default class DocumentType extends Model<DocumentTypeDTO, DocumentType> {
  @observable id = Id.none
  @observable shortId = Id.none
  @observable name = ''
  @observable heading = ''
  @observable shortHelpText = ''
  @observable longHelpText = ''
  @observable imageUrl: string = ''
  @observable previewUrl: string = ''
  @observable uploaderUserType = UploaderUserType.Pro
  @observable fields: Array<DocumentTypeField> = []

  constructor() {
    super()
    makeObservable(this)
  }

  static get none() {
    return lazyNone()
  }

  parse(json: Partial<DocumentTypeDTO>): Partial<DocumentType> {
    return {
      id: json.id,
      shortId: json.short_id,
      name: json.name,
      heading: json.heading,
      shortHelpText: json.short_help_text,
      longHelpText: json.long_help_text,
      imageUrl: json.image_url || '',
      previewUrl: json.preview_url || '',
      uploaderUserType: json.uploader_user_type,
      fields: json.fields || [],
    }
  }
}

const lazyNone = once(() =>
  new DocumentType().set({
    name: 'Unknown',
  }),
)

export type DocumentTypeField = {
  id: string
  label: string
  required?: boolean
  description?: string
  sort_order: number
} & (
  | {
      type: 'BOOL' | 'DATE'
    }
  | {
      type: 'TEXT'
      is_multi?: boolean
    }
  | {
      type: 'NUMERIC'
      is_integer?: boolean
    }
  | {
      type: 'OBJECT' | 'ARRAY'
      fields: Array<DocumentTypeField>
    }
)
